<template>
  <div :class="{'box':!boxOff}">
    <h1 class="title" v-if="title">{{ title }}</h1>
    <table class="table is-fullwidth is-striped is-hoverable">
      <thead>
        <tr>
          <!-- <th>Folder</th> -->
          <th class="files-title">{{header}}</th>
          <th>Brief</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="file in files" :key="file.id">
          <td>
            <router-link :to="'/e-studio/'+file.id">
              <span class="icon is-small">
                <img src="../../assets/img/icons/file.svg" />
              </span>
              {{ file.name }}
            </router-link>
          </td>
          <td>
            <a
              @click="gotoProject($store.state.auth.user.groups[0].id, $store.state.auth.user.id, file.project_id)"
            >Brief</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import BaseHelper from "@/helpers/BaseHelper";

export default {
  name: "TaskBrowser",
  components: {},
  mixins: [BaseHelper],

  props: {
    hasNav: {
      type: Boolean,
      required: false,
      default: true
    },
    boxOff: {
      type: Boolean,
      required: false,
      default: false
    },
    files: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: false,
      default: "journal"
    },
    title: {
      type: String,
      required: false,
      default: ""
    },
    header: {
      type: String,
      required: false,
      default: "Documents"
    }
  },

  data() {
    return {
      isLoading: false
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" >
@import "../../assets/scss/variables";
.files-title {
  color: $orange !important;
  font-weight: bold !important;
}
</style>